import React from 'react';
import PropTypes from 'prop-types';

const InfoSection = ({ title, offerDesc, time, price, label, gateway }) => (
  <div className="col-md-3 col-xs-6">
    <div className="tit-peli texto-chico col-xs-12">
      <h4>{title}</h4>
    </div>
    <div className="col-xs12 " />
    <div className="col-sm-12">
      <p className="datos texto-gray margin-0 padding-top-1">
        <strong>
          <b>{offerDesc}</b> {time}
        </strong>
      </p>
    </div>
    <div className="col-sm-12">
      <p className="datos texto-gray">
        <strong>
          {label.price}
          <span className="texto-brand">{` ${label.currency}${price}`}</span>
          {` - ${gateway}`}
        </strong>
      </p>
    </div>
  </div>
);

InfoSection.propTypes = {
  title: PropTypes.string,
  offerDesc: PropTypes.string,
  time: PropTypes.string,
  price: PropTypes.string,
  gateway: PropTypes.string,
  label: PropTypes.object,
};

export default InfoSection;
